"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var MenuItemTheme = function MenuItemTheme(colors) {
  return {
    defaultProps: {
      disableRipple: true
    },
    styleOverrides: {
      root: {
        color: colors.ultramarine,
        '&:hover': {
          color: colors.hover,
          backgroundColor: colors.bleuDigital05
        },
        '&:active, &.Mui-focusVisible': {
          color: colors.click,
          backgroundColor: colors.bleuDigital10
        },
        '&.Mui-selected': {
          backgroundColor: colors.bleuDigital10,
          '&:hover': {
            backgroundColor: colors.bleuDigital10
          }
        },
        '&.Mui-disabled': {
          backgroundColor: colors.white
        }
      }
    }
  };
};

var _default = MenuItemTheme;
exports["default"] = _default;